import { render, staticRenderFns } from "./persistentvolumeclaim.vue?vue&type=template&id=9e73a030&"
import script from "./persistentvolumeclaim.vue?vue&type=script&lang=js&"
export * from "./persistentvolumeclaim.vue?vue&type=script&lang=js&"
import style0 from "./persistentvolumeclaim.vue?vue&type=style&index=0&id=9e73a030&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports